module.exports = __webpack_public_path__ + "static/media/logo-delete-orphanage.550f8307.svg";